import { lazy } from 'react'

// lazy load here map to not include here.js in the main bundle
export const LazyHereMap = lazy(() => import('./HereMap'))
